import * as React from "react";
import { isRejected } from "../../../../helpers";
import { FreeHtml } from "sb-resp-ui";
const baseClass = "rj-yourbet__desktop-message";
export class MessageDesktop extends React.PureComponent {
    render() {
        let cls = baseClass + (this.props.modifier ? ` ${baseClass}--${this.props.modifier}` : "");
        if (isRejected(this.props.type)) {
            cls += ` ${baseClass}--error`;
        }
        return (React.createElement("div", { className: cls },
            React.createElement(FreeHtml, { html: this.props.label })));
    }
}
//# sourceMappingURL=MessageDesktop.js.map